import { defineMessages } from "react-intl";

const messages = {
  resetPasswordSuccess: { id: "ResetPassword.resetPasswordSuccess" }
};

const definedMessages = defineMessages(messages);

export default definedMessages;
